export default "/fonts/iconly.ttf?75929426861cf7126a33041cccb89f4f";